// 추천인 자동 입력 — 가입 URL 의 쿼리스트링(?ref=...)으로 들어온 추천인을 회원가입 폼까지 나른다.
//
// 가입은 /auth/sign-up → /2 → /3 → /4 로 라우트가 바뀌며 진행돼 최초 URL 의 쿼리스트링이 사라지고,
// 랜딩(/)으로 먼저 들어와 가입 버튼을 누르는 경로도 있다. 그래서 값을 본 시점에 sessionStorage 에
// 적어두고 3단계 폼이 그때 꺼내 쓴다. 탭을 닫으면 사라지는 게 맞는 값이라 localStorage 는 쓰지 않는다.

const REFERRAL_STORAGE_KEY = "pathrade.signUp.referral";

// 마케팅 링크마다 파라미터 이름이 갈려 셋 다 받는다. 앞에 있는 것이 우선이다.
const REFERRAL_QUERY_KEYS = ["ref", "referrer", "recommender"];

// user.recommender 컬럼이 varchar(50) 이라 그 이상은 어차피 잘린다.
export const REFERRAL_MAX_LENGTH = 50;

export function normalizeReferral(raw: string | null | undefined): string {
  return (raw ?? "").trim().slice(0, REFERRAL_MAX_LENGTH);
}

function readStoredReferral(): string {
  if (typeof window === "undefined") {
    return "";
  }
  try {
    return normalizeReferral(window.sessionStorage.getItem(REFERRAL_STORAGE_KEY));
  } catch {
    // 시크릿 모드 등 sessionStorage 가 막힌 환경에서는 자동 입력만 포기한다.
    return "";
  }
}

function writeStoredReferral(value: string) {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.sessionStorage.setItem(REFERRAL_STORAGE_KEY, value);
  } catch {
    // 저장에 실패해도 가입 자체는 계속 진행돼야 한다.
  }
}

/**
 * 주어진 쿼리스트링에 추천인이 있으면 저장하고 그 값을, 없으면 이미 저장해둔 값을 돌려준다.
 * 가입 URL 을 볼 수 있는 곳(라우터 로더, 가입 페이지)에서 호출한다.
 */
export function captureReferral(search: string): string {
  const params = new URLSearchParams(search);
  for (const key of REFERRAL_QUERY_KEYS) {
    const value = normalizeReferral(params.get(key));
    if (value !== "") {
      writeStoredReferral(value);
      return value;
    }
  }
  return readStoredReferral();
}

/** 현재 브라우저 URL 기준으로 추천인을 얻는다. */
export function resolveReferral(): string {
  if (typeof window === "undefined") {
    return "";
  }
  return captureReferral(window.location.search);
}

/** 가입이 끝나면 지운다 — 남겨두면 같은 탭에서 다음 가입에도 따라붙는다. */
export function clearReferral() {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.sessionStorage.removeItem(REFERRAL_STORAGE_KEY);
  } catch {
    // 지우지 못해도 세션이 끝나면 사라진다.
  }
}
